import { render, staticRenderFns } from "./CbsDashboardRow.vue?vue&type=template&id=7a4f8641&scoped=true"
import script from "./CbsDashboardRow.vue?vue&type=script&lang=js"
export * from "./CbsDashboardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f8641",
  null
  
)

export default component.exports